import { __assign, __awaiter, __generator, __read, __values } from "tslib";
import fs from 'fs';
import path from 'path';
import { prompt } from 'enquirer';
import fg from 'fast-glob';
import dedent from 'dedent';
import del from 'del';
import appRoot from 'app-root-path';
import { mutatePackageJSON } from '../utils';
export var trimObject = function (obj) {
    return Object.entries(obj).reduce(function (o, _a) {
        var _b = __read(_a, 2), k = _b[0], v = _b[1];
        o[k] = (v || '').trim();
        return o;
    }, {});
};
export var guessGithubUsername = function () {
    var e_1, _a;
    var files = fg
        .sync('../../../**/!(node_modules)/*/package.json', {
        dot: true,
        suppressErrors: true
    })
        .filter(function (x) { return !x.includes('node_modules'); })
        .slice(0, 50)
        .map(function (x) {
        var _a, _b;
        var json = null;
        try {
            json = (_b = (_a = JSON.parse(fs.readFileSync(x, 'utf8'))) === null || _a === void 0 ? void 0 : _a.repository) === null || _b === void 0 ? void 0 : _b.url;
        }
        catch (_c) { }
        if (typeof json === 'string') {
            var matchResults = json.match(usernameRegex);
            if (matchResults) {
                return matchResults[1];
            }
        }
        return null;
    })
        .filter(Boolean)
        .reduce(function (map, _s) {
        var _a;
        var s = _s;
        map.set(s, ((_a = map.get(s)) !== null && _a !== void 0 ? _a : 0) + 1);
        return map;
    }, new Map());
    var max = '';
    var maxCount = -1;
    try {
        for (var _b = __values(files.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), username = _d[0], count = _d[1];
            if (count > maxCount) {
                maxCount = count;
                max = username;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return maxCount > 1 ? max : '';
};
var usernameRegex = /github\.com[:\/]([^\/]*)/;
export var setup = function () { return __awaiter(void 0, void 0, void 0, function () {
    var initialProjectLoc, initialProjectDir, _a, projectName, projectDescription, githubUsername, authorName, authorEmail, variableName, year, mapper, replacerRegex, confirm, blacklist, walkSync, files, results;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                initialProjectLoc = appRoot.path.split(path.sep);
                initialProjectDir = initialProjectLoc[initialProjectLoc.length - 1];
                return [4, prompt({
                        type: 'snippet',
                        name: 'meta',
                        message: 'Fill out the fields in package.json',
                        template: dedent("{\n        \"name\": \"${projectName" + (initialProjectDir === 'create-typescript-react-library'
                            ? ''
                            : ":" + initialProjectDir) + "}\",\n        \"description\": \"${projectDescription}\",\n        \"homepage\": \"https://github.com/${githubUsername:" + guessGithubUsername() + "}/${projectName}\",\n        \"author\": {\n          \"name\": \"${authorName}\",\n          \"email\": \"${authorEmail}\",\n          \"url\": \"https://github.com/${githubUsername}\"\n        },\n        \"repository\": {\n          \"type\": \"git\",\n          \"url\": \"https://github.com/${githubUsername}/${projectName}.git\"\n        }\n      }") + '\n',
                        result: (function (o) {
                            return trimObject(o.values);
                        }),
                        validate: (function (_, state) {
                            var values = trimObject(state.value.values);
                            if (!/^[a-z0-9-~][a-z0-9-._~]*$/.test(values.projectName)) {
                                return 'project name is invalid';
                            }
                            if (!/^[a-z\d](?:[a-z\d]|-(?=[a-z\d])){0,38}$/i.test(values.githubUsername)) {
                                return 'github username is invalid';
                            }
                            if (values.authorName.length === 0) {
                                return 'author name is invalid';
                            }
                            if (!/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(values.authorEmail)) {
                                return 'author email is invalid';
                            }
                            return true;
                        })
                    })];
            case 1:
                _a = (_c.sent()).meta, projectName = _a.projectName, projectDescription = _a.projectDescription, githubUsername = _a.githubUsername, authorName = _a.authorName, authorEmail = _a.authorEmail;
                return [4, prompt({
                        type: 'snippet',
                        name: 'meta',
                        message: 'What variable should your library be exported as?',
                        template: dedent('\n' +
                            ("\n      // Default import name (for basic usage example)\n      import ${variableName:" + ((_b = projectName
                                .split(/[_\-]/g)
                                .reduce(function (s, x) {
                                return "" + s + (x.length > 0 ? "" + x[0].toUpperCase() + x.slice(1) : '');
                            }, '')) !== null && _b !== void 0 ? _b : 'VariableName') + "} from '" + projectName + "'\n\n      // Window global name (for use in a web browser)\n      window.${variableName}.foo(bar)\n      ")) + '\n',
                        result: (function (o) {
                            return trimObject(o.values);
                        }),
                        validate: (function (_, state) {
                            var values = trimObject(state.value.values);
                            try {
                                new Function(values.variableName, 'var ' + values.variableName);
                            }
                            catch (_a) {
                                return 'variable name is invalid';
                            }
                            return true;
                        })
                    })];
            case 2:
                variableName = (_c.sent()).meta.variableName;
                year = "" + new Date().getFullYear();
                mapper = {
                    'gocvmmeyaahgakggbjwmcmif': projectName,
                    'Gocvmmeyaahgakggbjwmcmif': variableName,
                    'xrdnwftmsmirdshgpfoyocjh': githubUsername,
                    'zkhshfmpcvllotfgoigdwyrr': authorName,
                    'fnrnhzcp@gohyrqjsyole.jv': authorEmail,
                    'rwmgkcxafpdrkuvtfszrfvwv': projectDescription,
                    '276768723349764835332642': year
                };
                replacerRegex = new RegExp(Object.keys(mapper)
                    .map(function (key) { return key.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'); })
                    .join('|'), 'g');
                return [4, prompt({
                        type: 'confirm',
                        name: 'confirm',
                        message: dedent("Do these look right?\n\n      Project Name:        " + JSON.stringify(projectName) + "\n      Variable Name:       " + JSON.stringify(variableName) + "\n      Github Username:     " + JSON.stringify(githubUsername) + "\n      Author Name:         " + JSON.stringify(authorName) + "\n      Author Email:        " + (authorEmail ? JSON.stringify(authorEmail) : '(Field will be removed)') + "\n      Project Description: " + JSON.stringify(projectDescription) + "\n\n      IMPORTANT: you can only run this once and there's no undo!")
                    })];
            case 3:
                confirm = (_c.sent()).confirm;
                if (!confirm) {
                    console.log('\nSetup cancelled.');
                    process.exit(0);
                }
                console.log('Replacing starter readme with library readme');
                fs.writeFileSync(path.join(appRoot.path, 'README.md'), dedent("\n      # `gocvmmeyaahgakggbjwmcmif`\n\n      [![npm version](https://img.shields.io/npm/v/gocvmmeyaahgakggbjwmcmif.svg?style=flat-square)](https://www.npmjs.com/package/gocvmmeyaahgakggbjwmcmif)\n      [![test coverage](https://img.shields.io/badge/dynamic/json?style=flat-square&color=brightgreen&label=coverage&query=%24.total.branches.pct&suffix=%25&url=https%3A%2F%2Funpkg.com%2F" + encodeURIComponent(projectName) + "%2Fcoverage%2Fcoverage-summary.json)](https://www.npmjs.com/package/gocvmmeyaahgakggbjwmcmif)\n      [![GitHub Workflow Status](https://img.shields.io/github/workflow/status/xrdnwftmsmirdshgpfoyocjh/gocvmmeyaahgakggbjwmcmif/Release?style=flat-square)](https://github.com/xrdnwftmsmirdshgpfoyocjh/gocvmmeyaahgakggbjwmcmif/actions?query=workflow%3ARelease)\n\n      " + (projectDescription
                    ? "> **" + projectDescription.replace(/[!"#$%&'()*+,./:;<=>?@\-\[\\\]\^\_\`\{\|\}\~]/g, '\\$&') + "**"
                    : '') + "\n\n      ## Installation\n\n      ```sh\n      npm install gocvmmeyaahgakggbjwmcmif --save\n      # yarn add gocvmmeyaahgakggbjwmcmif\n      ```\n\n      Alternatively, there are also client web builds available:\n\n      <!-- IMPORTANT: Do not delete or change the comments in the code block below -->\n\n      ```html\n      <!-- Dependencies -->\n\n      <!-- window.Gocvmmeyaahgakggbjwmcmif -->\n      <script src=\"https://unpkg.com/gocvmmeyaahgakggbjwmcmif/dist/gocvmmeyaahgakggbjwmcmif.umd.js\"></script>\n      ```\n\n      ## Documentation\n\n      - [`Docs`](docs)\n      - [`API`](docs/api)\n\n      ## License\n\n      MIT\n\n      <!-- Original starter readme: https://github.com/tbjgolden/create-typescript-react-library -->\n      " + '\n'));
                console.log('Starting find and replace');
                blacklist = new Set('build|compiled|coverage|dist|node_modules|.git'.split('|'));
                walkSync = function (dir, callback) {
                    var files = fs.readdirSync(dir);
                    files.forEach(function (file) {
                        if (!blacklist.has(file)) {
                            var filepath = path.join(dir, file);
                            var stats = fs.statSync(filepath);
                            if (stats.isDirectory()) {
                                walkSync(filepath, callback);
                            }
                            else if (stats.isFile() && !blacklist.has(file)) {
                                callback(filepath, stats);
                            }
                        }
                    });
                };
                files = [];
                walkSync(appRoot.path, function (filepath, stats) {
                    if (stats.size < 50000) {
                        files.push(filepath);
                    }
                });
                return [4, Promise.all(files.map(function (file) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2, new Promise(function (resolve, reject) {
                                    fs.readFile(file, { encoding: 'utf8' }, function (err, str) {
                                        if (err)
                                            return reject(err);
                                        fs.writeFile(file, str.replace(replacerRegex, function (str) { return mapper[str]; }), function (err) {
                                            if (err)
                                                return reject(err);
                                            resolve(null);
                                        });
                                    });
                                }).catch(function () { return file; })];
                        });
                    }); }))];
            case 4:
                results = (_c.sent()).filter(function (result) { return result !== null; });
                if (results.length > 0) {
                    console.log('Could not find and replace in files:');
                    results.sort().forEach(function (file) {
                        console.log(" - \"" + path.relative(appRoot.path, file) + "\"");
                    });
                }
                console.log('Finished find and replace');
                return [4, mutatePackageJSON({
                        author: __assign(__assign({ name: authorName }, (authorEmail ? { email: authorEmail } : {})), { url: "https://github.com/" + githubUsername })
                    })];
            case 5:
                _c.sent();
                console.log('Updated package.json');
                return [4, del(path.join(appRoot.path, 'config/meta'))];
            case 6:
                _c.sent();
                console.log('Removed create-typescript-react-library logic');
                return [2];
        }
    });
}); };
//# sourceMappingURL=index.js.map